import dayjs from 'dayjs';
import FileSaver from 'file-saver';
import ReactGA from 'react-ga4';

export const firstLetterCapsOnly = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatDate = (value: string) => {
  const date = new Date(value);
  const formatted = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
  return formatted;
};

export const formatLongDate = (value: string) => {
  const date = dayjs(value);
  if (!date.isValid()) return undefined;
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date.toDate());
};

export const recordGoogleAnalyticsEvent = (category: string, action: string, label: string) => {
  return ReactGA.event({
    category,
    action,
    label,
  });
};

export const recordGoogleAnalyticsSend = (hitType: string, page: string, title: string) => {
  return ReactGA.send({
    hitType,
    page,
    title,
  });
};

export const downloadPDFByUri = (uri: string, fileName: string) => {
  fetch(uri)
    .then(res => res.blob())
    .then(blob => {
      FileSaver.saveAs(blob, fileName.replace(/,/g, ''));
    });
};
